module.exports = __webpack_public_path__ + "img/star.0d93a337.svg";